var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadioButtonChecked = function SvgRadioButtonChecked(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 1,
    stroke: "#E5E5EA",
    rx: 8.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 5,
    fill: "#007AFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadioButtonChecked);
export default ForwardRef;